import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { RecipientsDisplayComponent } from "../recipients-display/recipients-display.component";
import { QuestionnaireCategoryCountDto } from 'src/app/models/questionnaireCategory.model';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-category-filter',
    templateUrl: './category-filter.component.html',
    styleUrls: ['./category-filter.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CategoryFilterComponent, multi: true }],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        FormsModule,
        MatCheckboxModule,
        TranslateDirective, TranslatePipe,
        RecipientsDisplayComponent
    ]
})
export class CategoryFilterComponent implements ControlValueAccessor, OnInit {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  categoryIdFromSelectedFilter?: number;

  ngOnInit() {
    this.categoryIdFromSelectedFilter =  this.selectedFilter$()?.categoryId;
  }

  @Input() categoriesList: QuestionnaireCategoryCountDto[] | undefined | null;
  valueControl = new FormControl<number | null>(null);
  readonly searchControl = new FormControl<string | QuestionnaireCategoryCountDto>('');
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  selectCategory(categoryId: number) {
    this.valueControl.setValue(categoryId);
    if (this.callBackFunction) {
      this.callBackFunction(this.valueControl.value);
    }
  }
}
